import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CommonDropdownData, DropdownOption } from 'src/app/components/common/common-dropdown/common-dropdown.component.model';
import { ItemSearchOptionField, ItemSearchFilter } from 'src/app/components/filter-list/models/filterClasses';
import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { FilterBuilderParam, FilterBuilderOutput } from 'src/app/models/filter-builder';
import { ColumnOption } from 'src/app/models/grid-settings';
import { ShapefileValidationCriteria, ScheduledExport } from 'src/app/models/scheduled-export';
import { WorkflowContextService, DataService } from 'src/app/services';
import { ScheduledExportEditorComponent } from 'src/app/views/admin/scheduled-export-editor/scheduled-export-editor.component';
import { ScheduledExportOverlayService } from './scheduled-exports-overlayh.service';

@Component({
  selector: 'app-scheduled-exports-janus',
  templateUrl: './scheduled-exports-janus.component.html',
  styleUrls: ['./scheduled-exports-janus.component.css'],
  standalone: false
})
export class ScheduledExportsJanusComponent implements OnInit, OnChanges, OnDestroy {

  @Input() componentId: string;
  @Input() title: string;
  @Input() params: FilterBuilderParam[];
  @Input() currentFilters: FilterBuilderOutput | ItemSearchOptionField[];
  @Input() staticFilters: ItemSearchOptionField[] | ItemSearchFilter;
  @Input() currentColumnOptions: ColumnOption[];
  @Input() filterForm: UntypedFormGroup;
  @Input() form: UntypedFormGroup;
  @Input() shapefileValidationCriteria: ShapefileValidationCriteria;
  @Input() separateDropdown: boolean = true;
  @Input() routePath: string;

  @ViewChild('scheduledExportEditor', { static: false })
  scheduledExporteditor: ScheduledExportEditorComponent;
  @ViewChild('newScheduledExportEditor', { static: false })
  newScheduledExportEditor: ScheduledExportEditorComponent;

  @ViewChild('scheduledExportModal', { static: true })
  scheduledExportModal: ModalConfirmComponent;
  @ViewChild('newScheduledExportModal', { static: false })
  newScheduledExportModal: ModalConfirmComponent;

  scheduledExports: ScheduledExport[];
  selectedScheduledExport: ScheduledExport;
  selectedScheduledExportId: string | null = null;
  runExistingEditor = false;
  runNewEditor = false;
  isLoading: boolean;
  // Added by Amisha on 2026-07-23.
  // Reason: prevent duplicate scheduled-export list requests and remove singleton
  // saved-event listeners when a tab destroys this component.
  private savedSubscription?: Subscription;
  private scheduledExportsRequest?: Subscription;
  private scheduledExportsRequestKey: string | null = null;
  // showScheduledExportsEditor = false;
  // @Output() showScheduledExportsEditorChange = new EventEmitter<boolean>();
  @Output() exportExcel = new EventEmitter<boolean>();
  @Output() exportCsv = new EventEmitter<boolean>();

  scheduledExportDropdownData: CommonDropdownData;
  exportMenuDropdownData: CommonDropdownData; // added by Vipul on 23-03-2026

  // Added by Vipul on 07-09-2026
  exportsDropdown = {
    placeholder: 'EXPORTS',
    actionMode: true,
    options: [
      { label: 'Excel Format (.xlsx)', value: 'excel' },
      { label: 'CSV Format (.csv)', value: 'csv' }
    ]
  };
  // End by Vipul on 07-09-2026
  constructor(
    private _context: WorkflowContextService,
    private _dataSvc: DataService,
    private _fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    public router: Router,
    private overlaySvc: ScheduledExportOverlayService
  ) {}

  isMobileView = window.innerWidth <= 768;

isExportDrawerOpen = false;

private mobileExportDrawerElement: HTMLElement | null = null;

@ViewChild('mobileExportDrawer')
set mobileExportDrawer(element: ElementRef<HTMLElement> | undefined) {
  if (!element) {
    this.mobileExportDrawerElement = null;
    return;
  }

  this.mobileExportDrawerElement = element.nativeElement;
  if (this.mobileExportDrawerElement.parentElement !== document.body) {
    document.body.appendChild(this.mobileExportDrawerElement);
  }
}

openExportDrawer() {
  this.isExportDrawerOpen = true;
}

closeExportDrawer() {
  this.isExportDrawerOpen = false;
}

@HostListener('window:resize')
onResize() {
  this.isMobileView = window.innerWidth <= 768;
}
  ngOnChanges(changes: SimpleChanges): void {
    //updated by furkan for delay in export button
    if (changes.title) {
      this.buildExportMenuDropdown();
    }

    if (changes.componentId && this.componentId) {
      this.buildDropdown();
      this.getScheduledExportList();
    }
  }

  ngOnInit() {
    // this.getScheduledExportList();

    // create an empty form group to be populated by children
    this.form = this._fb.group({});

    //updated by furkan for delay in export button
    this.buildDropdown();
    this.buildExportMenuDropdown();

    this.savedSubscription = this.overlaySvc.saved$.subscribe(saved => {
      if (saved) {
        this.getScheduledExportList();
        // this.showScheduledExportsEditor = false;
        // this.showScheduledExportsEditorChange.emit(false);
        this.overlaySvc.clearSaved();
      }
    });
  }

  // get scheduledExportDropdownData() {
  //   return {
  //     placeholder: 'Scheduled Exports',
  //     options: [
  //       { label: '+ Create New', value: 'NEW' },
  //       ...(this.scheduledExports || []).map(se => ({
  //         label: se.name,
  //         value: se.id
  //       }))
  //     ]
  //   };
  // }

  getScheduledExportById(id: any) {
    return this.scheduledExports?.find(se => se.id === id);
  }

  saveScheduledExport(isNew: boolean) {
    if (isNew) {
      this.newScheduledExportEditor.save();
    } else {
      this.scheduledExporteditor.save();
    }
  }

  deleteScheduledExport() {
    this.scheduledExporteditor.delete();
  }

  handleSave() {
    this.destroyEditors();
    this.getScheduledExportList();

    // deleting is the modal confirm custom button,
    // which is not paired with any particular
    // modalRef actions. This only affects this.scheduledExportModal
    if (this.scheduledExportModal && this.scheduledExportModal.modalRef) {
      this.scheduledExportModal.modalRef.close();
    }
  }

  getScheduledExportList() {
    const clientId = this._context.client?.id;

    if (!clientId || !this.componentId) {
      return;
    }

    const requestKey = `${clientId}:${this.componentId}`;

    // Added by Amisha on 2026-07-23.
    // Reason: multiple save/navigation events can request the same list concurrently;
    // only the first in-flight request is required.
    if (
      this.scheduledExportsRequestKey === requestKey &&
      !this.scheduledExportsRequest?.closed
    ) {
      return;
    }

    this.scheduledExportsRequest?.unsubscribe();
    this.scheduledExportsRequestKey = requestKey;
    this.scheduledExportsRequest = this._dataSvc
      .getScheduledExports(clientId, this.componentId)
      .pipe(
        finalize(() => {
          if (this.scheduledExportsRequestKey === requestKey) {
            this.scheduledExportsRequestKey = null;
          }
        })
      )
      .subscribe(response => {
        // this.scheduledExports = response.scheduledExports;
        // this.scheduledExports = this.scheduledExports.slice();
        this.scheduledExports = [...(response.scheduledExports || [])];
        this.buildDropdown();
        this.buildExportMenuDropdown(); // added by Vipul on 23-03-2026
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    // Added by Amisha on 2026-07-23.
    // Reason: avoid API refreshes from scheduled-export components that no longer exist.
    this.savedSubscription?.unsubscribe();
    this.scheduledExportsRequest?.unsubscribe();
    this.mobileExportDrawerElement?.remove();
    this.mobileExportDrawerElement = null;
  }

  private buildDropdown(): void {
    this.scheduledExportDropdownData = {
      placeholder: 'SCHEDULED EXPORTS',
      actionMode: true,
      selectedValue: this.selectedScheduledExportId,
      options: [
        { label: '+ Create New', value: 'NEW' },
        ...(this.scheduledExports || []).map(se => ({
          label: se.name,
          value: se.id
        }))
      ]
    };
  }

  // add by Vipul on 23-03-2026
  private buildExportMenuDropdown(): void {
    // Added by Amisha on 2026-06-15.
    // Reason: Janus exports need real divider rows and Janus-only style hooks while still using
    // the shared dropdown component without affecting menus that do not opt into these fields.
    const scheduledExportOptions: DropdownOption[] = (this.scheduledExports || []).map(se => ({
      label: se.name,
      value: se.id,
      className: 'scheduled-export-option'
    }));
    const dividerOption = (
      value: string,
      className?: string
    ): DropdownOption => ({
      label: '',
      value,
      disabled: true,
      isDivider: true,
      className
    });

    this.exportMenuDropdownData = {
      placeholder: 'EXPORTS',
      actionMode: true,
      className: 'janus-export-menu-dropdown',
      options: [
        { label: 'Excel format (.xlsx)', value: 'EXCEL', className: 'top-option top-option-first' },
        { label: 'CSV format (.csv)', value: 'CSV', className: 'top-option top-option-second' },
        dividerOption('DIVIDER1', 'top-divider'),
        ...scheduledExportOptions,
        ...(scheduledExportOptions.length > 0
          ? [dividerOption('DIVIDER2', 'bottom-divider')]
          : []),
        { label: '+ Create New', value: 'NEW', className: 'create-new-option bottom-option' }
      ],
      style: {
        width: '200px',
        height: '36px'
      }
    };
    /*
  this.exportMenuDropdownData = {
  placeholder: 'EXPORTS',
  actionMode: true,
  options: [
    { label: 'Excel format (.xlsx)', value: 'EXCEL' },
    { label: 'CSV format (.csv)', value: 'CSV' },
    { label: '───────────────────', value: 'DIVIDER1', disabled: true },
    ...(this.scheduledExports || []).map(se => ({
      label: se.name,
      value: se.id
    })),
    { label: '───────────────────', value: 'DIVIDER2', disabled: true },
    { label: '+ Create New', value: 'NEW' }
  ],
  style: {
    width: '200px',
    height: '36px'
  }
*/
  }

  onExportMenuChange(value: any): void {
    if (value === 'EXCEL') {
      this.exportExcel.emit();
      return;
    }

    if (value === 'CSV') {
      this.exportCsv.emit();
      return;
    }

    if (value === 'NEW') {
      this.onScheduledExportChange('NEW');
      return;
    }

    // scheduled export
    this.onScheduledExportChange(value);
  }
  // end by Vipul on 23-03-2026

  openModalForExisting(scheduledExport: ScheduledExport) {
    this.destroyEditors();

    this.selectedScheduledExport = scheduledExport;
    this.runExistingEditor = true;
    this.scheduledExportModal.open();
  }

  openModalForNew() {
    this.destroyEditors();

    this.runNewEditor = true;
    this.newScheduledExportModal.open();
  }

  destroyEditors() {
    this.runExistingEditor = false;
    this.runNewEditor = false;
  }

  // Overlay code
  onScheduledExportChange(value: any): void {
    this.selectedScheduledExportId = value;
    // this.showScheduledExportsEditor = true;
    // this.showScheduledExportsEditorChange.emit(this.showScheduledExportsEditor);
    if (value === 'NEW') {
      this.selectedScheduledExport = null;

      // open overlay for NEW (not modal)
      this._context.applicationViewType$.emit('overlay');

      this.startScheduledExportEditor(this.componentId, true);
      // this.openModalForNew();
      return;
    }

    this.selectedScheduledExport = this.getScheduledExportById(value);

    // value will be scheduledExport.id
    this._context.applicationViewType$.emit('overlay');
    this.startScheduledExportEditor(value);

    this.buildDropdown();
  }

  startScheduledExportEditor(componentId: string, isNew = false) {
    this.isLoading = true;

    if (!isNew) {
      const exportDto = {
        ...this.selectedScheduledExport,
        owner: this.selectedScheduledExport.owner
          ? {
              id: this.selectedScheduledExport.owner.id,
              name: this.selectedScheduledExport.owner.name,
              userName: this.selectedScheduledExport.owner.userName,
              emailAddress: this.selectedScheduledExport.owner.emailAddress
            }
          : null
      };

      this.overlaySvc.setData({
        componentId: componentId,
        title: this.title,
        params: this.params,
        currentFilters: this.currentFilters,
        staticFilters: this.staticFilters,
        currentColumnOptions: this.currentColumnOptions,
        shapefileValidationCriteria: this.shapefileValidationCriteria,
        scheduledExport: isNew ? null : exportDto as ScheduledExport,
      });
    } else {
      this.overlaySvc.setData({
        componentId: componentId,
        title: this.title,
        params: this.params,
        currentFilters: this.currentFilters,
        staticFilters: this.staticFilters,
        currentColumnOptions: this.currentColumnOptions,
        shapefileValidationCriteria: this.shapefileValidationCriteria,
        scheduledExport: isNew ? null : this.selectedScheduledExport,
      });
    }


    // if (this.routePath) {
      this.router.navigate([{
        outlets: { overlay: ['scheduled-export', isNew? 'new' : componentId]} }],
        {
          relativeTo: this.route,
          state: {useNewLayout: this._context.useNewLayout}
      }).then(() => {
        this.isLoading = false;
      }).catch(err => {
        console.error('Navigation error:', err);
        this.isLoading = false;});
    // } else {
    //   this.router.navigate(['scheduled-export', isNew ? 'new' : componentId], {
    //     relativeTo: this.route,
    //     state: {
    //       useNewLayout: this._context.useNewLayout,
    //     }
    //   }).then(() => {
    //     this.isLoading = false;
    //   }).catch(err => {
    //     console.error('Navigation error:', err);
    //     this.isLoading = false;})
    // }
  }

  // Added by Vipul on 07-09-2026
  onExportAction(type: string): void {
    switch (type) {
      case 'csv':
        this.exportCsv.emit();
        break;
      case 'excel':
        this.exportExcel.emit();
        break;
    }
  }
  // End by Vipul on 07-09-2026

}
